import * as React from 'react';

const QuestionMarkIcon = ({
  ...props
}: React.SVGProps<SVGSVGElement> & { secondaryColor?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="transparent"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M7.99999 15.1668C11.6819 15.1668 14.6667 12.1821 14.6667 8.50016C14.6667 4.81826 11.6819 1.8335 7.99999 1.8335C4.3181 1.8335 1.33333 4.81826 1.33333 8.50016C1.33333 12.1821 4.3181 15.1668 7.99999 15.1668Z"
      stroke="black"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.05998 6.49989C6.21672 6.05434 6.52608 5.67863 6.93329 5.43931C7.34049 5.2 7.81925 5.11252 8.28477 5.19237C8.75029 5.27222 9.17253 5.51424 9.4767 5.87558C9.78087 6.23691 9.94735 6.69424 9.94665 7.16656C9.94665 8.49989 7.94665 9.16656 7.94665 9.16656"
      stroke="black"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 11.8335H8.00667"
      stroke="black"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default QuestionMarkIcon;
